<template>
  <div class="wt-number wt2-sg">
    <label @click.prevent>
      <span v-text="field.label" />
      <slot name="tooltip"></slot>
      <input
        type="number"
        :value="numberValue"
        :name="field.name"
        :min="field.minValue || 0"
        :max="field.maxValue || 9999"
        @blur="updateAndFixedNumberValue"
        @input="updateNumberValue"
        :step="step"
      />
    </label>
  </div>
</template>

<script>
import fieldsMixin from '../mixins/fields.vue';

export default {
  props: {
    field: {
      type: Object,
      required: true,
      validator(value) {
        return _.every(
          ['defaultValue', 'minValue', 'maxValue', 'name', 'label'],
          (prop) => _.includes(_.keys(value), prop)
        );
      },
    },
  },

  mixins: [fieldsMixin],

  data() {
    return {
      numberValue: 0,
      step: '',
    };
  },

  created() {
    const numberValue = _.isDefined(this.field.value)
      ? this.field.value
      : app.sfp(
          this.field.defaultValue,
          Math.pow(10, this.field.precision || 0)
        );
    this.numberValue = this.parseFloatAndToFixed(numberValue);

    this.emitChange({ newValue: this.numberValue, makeDirty: false });

    this.step = 1 / Math.pow(10, this.field.precision || 0);
    this.$watch('numberValue', (newValue) => {
      if (_.isDefined(this.field.maxValue) && newValue > this.field.maxValue) {
        this.numberValue = this.field.maxValue;
      }

      if (_.isDefined(this.field.minValue) && newValue < this.field.minValue) {
        this.numberValue = this.field.minValue;
      }

      this.emitChange({ newValue });
    });
  },

  mounted() {
    this.fieldReadyNextTick();
  },

  methods: {
    updateNumberValue(e) {
      const number = parseFloat(e.target.value);
      // fixed the integer to float if also the data
      // is undefined which means user use events like arrows, and then
      // we want to update, not when user type in input
      if (Number.isInteger(number) && _.isUndefined(e.data)) {
        // need to be toFixed!
        this.updateAndFixedNumberValue(e);
      } else {
        this.numberValue = number;
      }
    },

    updateAndFixedNumberValue(e) {
      this.numberValue = this.parseFloatAndToFixed(
        e.target.value === '' ? 0 : e.target.value
      );
    },

    parseFloatAndToFixed(value) {
      return parseFloat(value).toFixed(this.field.precision || 0);
    },
  },
};
</script>
